// jQuery(document).ready(function() {
//     jQuery('.mobile-menu__nav').each(function() {
//         var menuItemName = jQuery(this).find('.mobile-menu__nav-item').text().trim();
//         console.log(menuItemName);
//         if (menuItemName === 'Locations' || menuItemName === 'Financing' || menuItemName === 'Latest Flyer') {
//             jQuery(this).closest('li').addClass('mob-class');
//         }
//     });
// });


jQuery(document).ready(function(){

  
  jQuery('button[data-action="toggle-menu"]').click(function() {
    //alert("yes");
     jQuery("#cm-blocker").addClass("cm-blocker-active");
     jQuery("body").addClass("cm-blocker-body-active");    

    jQuery('.mobile-menu__panel').removeClass('is-open');
    
  });

  jQuery('#cm-blocker').click(function(){
      jQuery("#cm-blocker").removeClass("cm-blocker-active");
      jQuery("body").removeClass("cm-blocker-body-active");

    jQuery(".header__mobile-nav-toggle").attr("aria-expanded","false");
    jQuery(".mobile-menu").attr("aria-hidden","true");
    jQuery('.mobile-menu').css('max-height', '0px');

    jQuery('.mobile-menu__panel').removeClass('is-open');
  });


  
  //jQuery(".nav-bar__link").attr("href", "javascript:void(0);");
  jQuery(".cm-text").attr("href", "javascript:void(0);"); 
  //jQuery('.nav-dropdown ').hide();
  //jQuery('.icon--arrow-bottom').hide();


     
  jQuery('.nav-bar__item').click(function(){

    //alert(jQuery(this).find('.cm-text').text().trim());
    //alert(jQuery(this).find('.cm-text-no-display').text().trim().replace(/ /g,'').toLowerCase());
   // var cmtextnodisplay = jQuery(this).find('.cm-text-no-display').text().trim().replace(/ /g,'').toLowerCase();
    
   
    
    //jQuery("#cm-blocker").addClass("cm-blocker-active");
    //jQuery('body').addClass("cm-blocker-body-active");

    
    //alert(jQuery(this).text().trim());
    //alert(jQuery(this).text().replace(/ /g,'').toLowerCase());

    
    
    //jQuery(".header__mobile-nav-toggle").attr("aria-expanded","true");
    //jQuery(".header__mobile-nav-toggle").trigger("click");

    //jQuery(".header__mobile-nav-toggle").attr("aria-expanded","true");
    //jQuery(".mobile-menu").attr("aria-hidden","false");
    //jQuery(".mobile-menu__nav-link").trigger("click");


      // Select the button with data-action attribute
      //var button = jQuery('button[data-action="toggle-menu"]');
      // Trigger click event on the selected button
      //button.click();

    //alert(jQuery(window).height());

    var sheight = jQuery(window).height(); // 310px

    //jQuery(".header__mobile-nav-toggle").attr("aria-expanded","true");
    //jQuery(".mobile-menu").attr("aria-hidden","false");
    //jQuery('.mobile-menu').css('max-height', sheight+'px');

   /* setTimeout(function() {
      //alert("okk");
      // Select the button with data-action attribute
      var button = jQuery('button[data-action="toggle-menu"]');
  
      // Trigger click event on the selected button
      button.click();
    }, 2000);*/

    var chkMenuItem = "cm-"+jQuery(this).text().replace(/ /g,'').toLowerCase();
    //alert(chkMenuItem);


    //var chkMenuItemWithoutCm =jQuery(this).find('.cm-text').text().replace(/ /g,'').toLowerCase();
    //alert(chkMenuItemWithoutCm);

    var chkMenuItemWithoutCm =jQuery(this).find('.cm-text').text().trim().replace(/ /g,'').toLowerCase();
    //alert(chkMenuItemWithoutCm);

   
    if(chkMenuItemWithoutCm == 'mattresses')
    {
      jQuery("#cm-blocker").addClass("cm-blocker-active");
    jQuery('body').addClass("cm-blocker-body-active");
      
    jQuery(".header__mobile-nav-toggle").attr("aria-expanded","true");
    jQuery(".mobile-menu").attr("aria-hidden","false");
    jQuery('.mobile-menu').css('max-height', sheight+'px');
      
    jQuery('button[data-nav="cm-mattresses"]').trigger("click");
    }
    
    if(chkMenuItemWithoutCm == "furniture")
    {
      jQuery("#cm-blocker").addClass("cm-blocker-active");
    jQuery('body').addClass("cm-blocker-body-active");
      
    jQuery(".header__mobile-nav-toggle").attr("aria-expanded","true");
    jQuery(".mobile-menu").attr("aria-hidden","false");
    jQuery('.mobile-menu').css('max-height', sheight+'px');
      
    jQuery('button[data-nav="cm-furniture"]').trigger("click");
    }
    
    if(chkMenuItemWithoutCm == "appliances")
    {
      jQuery("#cm-blocker").addClass("cm-blocker-active");
    jQuery('body').addClass("cm-blocker-body-active");
      
    jQuery(".header__mobile-nav-toggle").attr("aria-expanded","true");
    jQuery(".mobile-menu").attr("aria-hidden","false");
    jQuery('.mobile-menu').css('max-height', sheight+'px');
      
    jQuery('button[data-nav="cm-appliances"]').trigger("click");
    }
    
    if(chkMenuItemWithoutCm == "electronics")
    {
      jQuery("#cm-blocker").addClass("cm-blocker-active");
    jQuery('body').addClass("cm-blocker-body-active");
      
    jQuery(".header__mobile-nav-toggle").attr("aria-expanded","true");
    jQuery(".mobile-menu").attr("aria-hidden","false");
    jQuery('.mobile-menu').css('max-height', sheight+'px');
      
    jQuery('button[data-nav="cm-electronics"]').trigger("click");
    }
    
    if(chkMenuItemWithoutCm == "homedecor")
    {
      jQuery("#cm-blocker").addClass("cm-blocker-active");
    jQuery('body').addClass("cm-blocker-body-active");
      
    jQuery(".header__mobile-nav-toggle").attr("aria-expanded","true");
    jQuery(".mobile-menu").attr("aria-hidden","false");
    jQuery('.mobile-menu').css('max-height', sheight+'px');
      
    jQuery('button[data-nav="cm-homedecor"]').trigger("click");
    }
    
    if(chkMenuItemWithoutCm == "locations")
    {
    //jQuery('button[data-nav="cm-locations"]').trigger("click");
    }


    
  });
});

